
// store/toastSlice.ts
import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  msg: "",
  state: "success",
  visible: false,
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (state, action) => {
        console.log("Showing toast with payload:", action.payload);
      if (Array.isArray(action.payload.msg)) {
        state.msg = action.payload.msg.join(", ");
      } else {
        state.msg = action.payload.msg;
      }
      // state.msg = action.payload.msg;
      state.state = action.payload.state;
      state.visible = true;
    },
    hideToast: (state) => {
      state.visible = false;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
